// Shadow DOM utilities
export { injectSparkyStyles } from './vanillaExtractShadow';

